import { render } from "./VerifyUser.vue?vue&type=template&id=4af4b5dd"
import script from "./VerifyUser.vue?vue&type=script&lang=js"
export * from "./VerifyUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__